import React, { Component } from "react";
import { FormControl, FormControlLabel, Typography, RadioGroup, Radio, Button } from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import CheckCircleRoundedIcon from "@material-ui/icons/CheckCircleRounded";
import CustomDialog from "../../../layout/CustomDialog";
import config from "../../../../config";

class IsSinglePropertyPtorAllowedDialog extends Component {
  state = {
    isSellOfAllTheProperty: true,
    isSellerIsForeignResident: false,
    isSellerHasAnotherPropertyInStateOfResidence: false,
    hasProofOfOnlyPropertyInStateOfResidence: false,
    isOnlyPropertyOfSellerFamily: true,
    isSellerSoldWithOnlyPropertyPtor: false,
    isSellerHasRightFor18Months: true,
    isSellerHadOntherPropertyIn2014: false,
    isPropertyExcludedBefore: false,
    isChecked: false,
    isZakai: false
  };

  render() {
    const isForeignResidentFollowUpEnabled = this.state.isSellOfAllTheProperty && this.state.isSellerIsForeignResident;
    const isProofQuestionEnabled =
      isForeignResidentFollowUpEnabled && !this.state.isSellerHasAnotherPropertyInStateOfResidence;
    let resultStatusClass = "is-pending";
    let resultText = "החלטת המערכת:";
    if (this.state.isChecked) {
      resultStatusClass = this.state.isZakai ? "is-eligible" : "is-not-eligible";
      resultText = this.state.isZakai ? "החלטת המערכת: זכאי" : "החלטת המערכת: לא זכאי";
    }

    return (
      <CustomDialog
        label="בדיקת זכאות לפטור דירה יחידה, לפי סעיף 49ב(2)"
        open={this.props.open}
        onClose={this.props.onClose}
        maxWidth="lg"
        paperClassName="deal-calc-dialog"
        isContentDivided={false}
      >
        <div className="deal-calc-dialog-layout">
          <div className="deal-calc-dialog-main">
            {this.renderYesNoRow({
              name: "isSellOfAllTheProperty",
              label: "האם המכירה הינה של כל זכויות המוכר בדירה?",
              isDisabled: false
            })}
            {this.renderYesNoRow({
              name: "isSellerIsForeignResident",
              label: "האם המוכר תושב חוץ?",
              isDisabled: !this.state.isSellOfAllTheProperty
            })}
            {this.renderYesNoRow({
              name: "isSellerHasAnotherPropertyInStateOfResidence",
              label: "האם ברשותו דירת מגורים נוספת במדינת תושבותו?",
              isDisabled: !isForeignResidentFollowUpEnabled
            })}
            {this.renderYesNoRow({
              name: "hasProofOfOnlyPropertyInStateOfResidence",
              label: "האם ברשותו הוכחה רשמית מהרשויות במדינת תושבותו, כי אין ברשותו דירת מגורים במדינת תושבותו?",
              isDisabled: !isProofQuestionEnabled
            })}
            {this.renderYesNoRow({
              name: "isOnlyPropertyOfSellerFamily",
              label: "האם הדירה הנמכרת הינה דירה יחידה של התא המשפחתי של המוכר?",
              isDisabled: !this.state.isSellOfAllTheProperty
            })}
            {this.renderYesNoRow({
              name: "isSellerSoldWithOnlyPropertyPtor",
              label: "אם המוכר מכר דירה אחרת \"בפטור דירה יחידה לפי סעיף 49ב'(2)\" במהלך ה- 18 חודשים שקדמו למכירה?",
              isDisabled: !this.state.isSellOfAllTheProperty
            })}
            {this.renderYesNoRow({
              name: "isSellerHasRightFor18Months",
              label: "האם המוכר הוא בעל הזכות בדירה הנמכרת במשך 18 חודשים לפחות ממועד השלמת בנייתה?",
              extraLabel: "(בדירת ירושה תילקח בחשבון התקופה בה החזיק המוריש בדירה מיום היותה דירת מגורים מזכה).",
              isDisabled: !this.state.isSellOfAllTheProperty
            })}
            {this.props.isBefore2018
              ? this.renderYesNoRow({
                  name: "isSellerHadOntherPropertyIn2014",
                  label: "האם ב 1/1/2014 היתה למוכר דירה נוספת מעבר לדירה הנמכרת?",
                  extraLabel: "לענין דירה נוספת או חלק ממנה ראה הבהרה מצד שמאל.",
                  isDisabled: !this.state.isSellOfAllTheProperty
                })
              : null}
            {this.renderYesNoRow({
              name: "isPropertyExcludedBefore",
              label:
                "האם הדירה הנמכרת הוחרגה בעבר מהגדרת \"דירה יחידה\" לפי סעיף 49 ג' (2) או (3), במסגרת מכירת דירת מגורים אחרת שנמכרה בפטור דירה יחידה לפי סעיף 49ב'(2)?",
              isDisabled: !this.state.isSellOfAllTheProperty
            })}
            <div className="deal-calc-dialog-actions">
              <Button className="deal-calc-dialog-check" variant="contained" onClick={this.isZakai}>
                בדוק זכאות
              </Button>
              {this.state.isChecked ? (
                <div
                  className={`deal-calc-dialog-result ${resultStatusClass}`}
                  ref={(element) => {
                    this.resultRef = element;
                  }}
                >
                  {this.state.isZakai ? <CheckCircleRoundedIcon /> : <WarningRoundedIcon />}
                  <Typography>{resultText}</Typography>
                </div>
              ) : null}
            </div>
          </div>
          <aside className="deal-calc-dialog-aside">
            <div className="deal-calc-dialog-note">
              <Typography className="deal-calc-dialog-note-title">הבהרה:</Typography>
              <Typography>
                יכול שתהיה לאדם דירה נוספת ו/או חלק מדירה ואף על זאת תיחשב הדירה הנמכרת כדירתו היחידה בהתאם לאמור בסעיף
                49ג לחוק מיסוי מקרקעין וזאת במידה והדירה הנוספת נכללת במסגרת החריגים הקבועים בחוק כדלקמן:
              </Typography>
              <Typography>
                (1) הדירה הנוספת נירכשה כתחליף לדירה הנמכרת {config.apaBoughtAsReplacementToSoldApaAmountOfMonths} חודשים
                טרם המכירה.
              </Typography>
              <Typography>(2) הדירה הנוספת הושכרה למגורים בשכירות מוגנת לפני יום כ"ב בטבת התשנ"ז (1 בינואר 1997).</Typography>
              <Typography>(3) חלקו של המוכר בדירה הנוספת אינו עולה על 1/3.</Typography>
              <Typography>(4) הדירה הנוספת הינה דירה שהתקבלה בירושה והתקיימו בה תנאי סעיף 49ב(5)(א) ו-(ב) לחוק.</Typography>
              <Typography>
                (5) הדירה הנוספת הינה דירה שהתקבלה בירושה וחלקו של המוכר בה אינו עולה על 50% וזאת ללא קשר לזהות המוריש
                ולמניין דירות המוריש ביום פטירתו.
              </Typography>
              <Typography>
                (6) הדירה הנוספת הינה דירה המשמשת למגורים או מיועדת למגורים לפי טיבה שהיא בבעלותו של איגוד, ולמוכר יש
                באמצעות זכויותיו באיגוד, במישרין או בעקיפין, חלק שאינו עולה על שליש בבעלות בה, ולגבי מוכר שירש את זכויותיו
                באיגוד - חלק שאינו עולה על מחצית בבעלות בה.
              </Typography>
            </div>
          </aside>
        </div>
      </CustomDialog>
    );
  }

  renderYesNoRow({ name, label, extraLabel, isDisabled }) {
    return (
      <div className={`deal-calc-dialog-row${isDisabled ? " is-disabled" : ""}`} key={name}>
        <div className="deal-calc-dialog-row-copy">
          <Typography className="deal-calc-dialog-row-label">{label}</Typography>
          {extraLabel ? <Typography className="deal-calc-dialog-row-hint">{extraLabel}</Typography> : null}
        </div>
        <FormControl component="fieldset" disabled={isDisabled}>
          <RadioGroup
            row
            name={name}
            value={Boolean(this.state[name]).toString()}
            onChange={(e) => this.handleOnChange(e)}
          >
            <FormControlLabel value={"true"} control={<Radio color="primary" />} label="כן" labelPlacement="end" />
            <FormControlLabel value={"false"} control={<Radio color="primary" />} label="לא" labelPlacement="end" />
          </RadioGroup>
        </FormControl>
      </div>
    );
  }

  isZakai = () => {
    let isZakai = true;
    if (!this.state.isSellOfAllTheProperty) isZakai = false;
    else if (this.state.isSellerIsForeignResident && this.state.isSellerHasAnotherPropertyInStateOfResidence) isZakai = false;
    else if (
      this.state.isSellerIsForeignResident &&
      !this.state.isSellerHasAnotherPropertyInStateOfResidence &&
      !this.state.hasProofOfOnlyPropertyInStateOfResidence
    )
      isZakai = false;
    else if (
      !this.state.isOnlyPropertyOfSellerFamily ||
      this.state.isSellerSoldWithOnlyPropertyPtor ||
      !this.state.isSellerHasRightFor18Months ||
      this.state.isSellerHadOntherPropertyIn2014 ||
      this.state.isPropertyExcludedBefore
    )
      isZakai = false;
    this.setState({ isZakai, isChecked: true }, () => {
      if (!this.resultRef) return;
      const dialogContent = this.resultRef.closest(".MuiDialogContent-root");
      if (dialogContent) dialogContent.scrollTop = 0;
      if (typeof this.resultRef.scrollIntoView === "function") {
        this.resultRef.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
    if (this.props.handleResults) this.props.handleResults({ target: { value: isZakai, name: "isSinglePropertyPtorAllowed" } });
  };

  handleOnChange(e) {
    let val = e.target.value;
    if (val === "true") val = true;
    if (val === "false") val = false;
    const newState = { ...this.state, [e.target.name]: val, isChecked: false, isZakai: false };
    this.handleDependencies(e, newState);
    this.setState(newState);
  }

  handleDependencies(e, newState) {
    if (e.target.name === "isSellOfAllTheProperty") {
      if (e.target.value === "false") {
        newState.isSellerIsForeignResident = false;
        newState.isSellerHasAnotherPropertyInStateOfResidence = false;
        newState.hasProofOfOnlyPropertyInStateOfResidence = false;
        newState.isOnlyPropertyOfSellerFamily = true;
        newState.isSellerSoldWithOnlyPropertyPtor = false;
        newState.isSellerHasRightFor18Months = true;
        newState.isSellerHadOntherPropertyIn2014 = false;
        newState.isPropertyExcludedBefore = false;
      }
    } else if (e.target.name === "isSellerIsForeignResident") {
      if (e.target.value === "false") {
        newState.isSellerHasAnotherPropertyInStateOfResidence = false;
        newState.hasProofOfOnlyPropertyInStateOfResidence = false;
      }
    } else if (e.target.name === "isSellerHasAnotherPropertyInStateOfResidence") {
      if (e.target.value === "true") {
        newState.hasProofOfOnlyPropertyInStateOfResidence = false;
      }
    }
  }
}

export default IsSinglePropertyPtorAllowedDialog;
